import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Star, CheckCircle2 } from "lucide-react";

export default function ReviewPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const apt = params.get("apt");
  const sig = params.get("sig");
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async () => {
    try {
      await api.post("/reviews", { appointment_id: apt, sig, rating, comment });
      setSent(true);
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  if (!apt || !sig) return <div data-testid="review-invalid" className="max-w-md mx-auto p-8 text-center text-slate-500">Enlace inválido</div>;

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <Card><CardContent className="p-6 sm:p-8">
        {sent ? (
          <div className="text-center py-4">
            <div className="mx-auto w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-3">
              <CheckCircle2 className="text-emerald-600" size={30}/>
            </div>
            <h1 className="text-xl font-bold text-slate-900">¡Gracias por tu reseña!</h1>
            <Button data-testid="review-home-btn" onClick={() => nav("/")} className="mt-5 bg-blue-600 hover:bg-blue-700">Volver al inicio</Button>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-slate-900">Califica tu cita</h1>
            <p className="text-sm text-slate-500 mt-1">Tu opinión es anónima para otros pacientes.</p>
            <div className="flex justify-center gap-2 my-6">
              {[1,2,3,4,5].map(n => (
                <button key={n} data-testid={`star-${n}`} onClick={() => setRating(n)}
                        className="transition-transform hover:scale-110">
                  <Star size={40} fill={n <= rating ? "#f59e0b" : "none"}
                        className={n <= rating ? "text-amber-500" : "text-slate-300"}/>
                </button>
              ))}
            </div>
            <Textarea data-testid="review-comment" placeholder="Comentario (opcional)"
                      value={comment} onChange={e => setComment(e.target.value)} rows={3}/>
            <Button data-testid="review-submit-btn" onClick={submit}
                    className="w-full mt-4 h-11 bg-blue-600 hover:bg-blue-700">
              Enviar reseña
            </Button>
          </>
        )}
      </CardContent></Card>
    </div>
  );
}
